import AudioAdsPage from './Page'

export default AudioAdsPage
